import { Navigate, Outlet, useLocation } from 'react-router';
import { AUTH_ROUTES } from '@/constants/routes/authRoutes';
import { getAccessToken } from '@/api/session';

const isAuthenticated = (): boolean => Boolean(getAccessToken());

const ProtectedRoute = () => {
  const location = useLocation();
  const authenticated = isAuthenticated();

  if (!authenticated) {
    return <Navigate to={AUTH_ROUTES.HOME} state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
